import gsap from 'gsap';

export default class ScrollTo {
  constructor(domElement) {
    this.dom = domElement;
    this.hash = this.dom.href.split('#').pop() || '#';
    this.target = document.querySelector(`#${this.hash}`);
    this.scroll;
    this.init();
  }

  init() {
    this.dom.addEventListener('click', e => this.smoothScroll(e));
  }

  smoothScroll(e) {
    e.preventDefault();
    const scrollTo = this.target.getBoundingClientRect().top + window.scrollY;
    const scrollDuration = 0.4 + Math.abs(window.scrollY - scrollTo) / window.innerHeight / 6;
    this.scroll = window.scrollY;
    gsap.to(this, {
      scroll: scrollTo,
      ease: 'power1.inout',
      duration: scrollDuration,
      onUpdate: () => {
        window.scrollTo(0, this.scroll);
      },
    });
  }
}
